package ru.villawonka.app.presentation.screens.setup.compose.layout

import androidx.compose.runtime.Composable
import ru.villawonka.app.presentation.screens.setup.compose.SetupCallbacks
import ru.villawonka.app.presentation.screens.setup.viewmodel.SetupUIState
import ru.villawonka.app.presentation.sharedviews.DefaultErrorStateLayout
import ru.villawonka.app.presentation.sharedviews.DefaultLoadingStateLayout

@Composable
fun SetupRootLayout(
    state: SetupUIState,
    callbacks: SetupCallbacks
) {
    when (state) {
        is SetupUIState.Loading -> DefaultLoadingStateLayout()
        is SetupUIState.Error -> DefaultErrorStateLayout(
            failure = state.failure,
            onRetryClick = callbacks.onRetryButtonClick
        )
        is SetupUIState.Step -> SetupStepStateLayout(state, callbacks)
    }
}